<template>
  <v-card class="pl-2 pr-1">
      <v-img src="@/assets/images/coming_soon.gif"/>
      <v-card-title>
        <v-row align="center" justify="center">
            <h3 class="primary--text font-weight-black text-uppercase">
              PRÓXIMAMENTE
            </h3>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="text-center primary--text" align="center" justify="center">
          <h3>Estamos trabajando para mejorar tu experiencia en Blú</h3><br><br>
          <h3>Este módulo te permitirá tener tu cuenta sincronizada con el SAT y de esta manera no tendrás que cargar tus facturas manualmente.</h3>
        </v-row>
      </v-card-text>
      <v-card-text class="text-center mt-6">
        <v-btn color="#0420BF" dark rounded @click="$emit('onClose')">
            <h4 class="font-weight-black">Cerrar</h4>
        </v-btn>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  name: 'OnConstruction',
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
</style>
